import { CommonUtilities } from '../../commonUtils';

export default class dashboardService {

    static statementsListing() {
        var url = 'approval/statementApproval/list/dashboard';
        return CommonUtilities.getData(url);
    }

    static async projectsListing() {
        var url = 'approval/statementApproval/projectlist/dashboard';
        return await CommonUtilities.getData(url);
    }

    static async tagColor() {
        var url = 'common/tagColor/listAll';
        return await CommonUtilities.getData(url);
    }

    static recyclePool() {
        var url = 'korrectPanel/monitoring/resetApplication';
        return CommonUtilities.getData(url);
    }

    static requestThirdParty(url: string, data: any) {
        return CommonUtilities.getDataThirdParty(url, CommonUtilities.buildQueryString(data, false, false));
    }

    static themeCustomization() {
        var url = 'DefaultValue/list';
        return CommonUtilities.getData(url);
    }

    static getClientDSP() {
        var url = 'client/getClientDSP';
        return CommonUtilities.getData(url);
    }

    static listSearchDSP() {
        var url = 'distributionList/dsp/listSearchDSP?basketId=2&region=&searchText=&pageNumber=1&pageSize=10000';
        return CommonUtilities.getData(url);
    }


      static getClientDSPFull() {
        var url = 'client/getListDSP?DigitalServiceProviderId=undefined';
        return CommonUtilities.getData(url);
    }
 
}